import forge from 'node-forge';
export const hashPassword = (password: string, sha: 'sha1' | 'sha256' = 'sha1') => {
  const md = forge.md[sha].create();

  md.update(password);
  const hex = md.digest().toHex();

  return hex;
};
